export const CalcularParcial = (item, tipo = '') => {

  const _parcial =
    parseFloat(item?.materiales?.valor || 0) +
    parseFloat(item?.contratista?.valor || 0) +
    parseFloat(item?.equipos?.valor || 0) +
    parseFloat(item?.mano_de_obra?.valor || 0) +
    parseFloat(item?.transporte?.valor || 0) +
    parseFloat(item?.viaticos?.valor || 0);


  return _parcial//*(tipo=='M' ? parseInt(item.frecuencia) : 1);
};

export const sanearNumero = (valor, opciones = {}) => {
  const {
    permitirNegativo = true,
    decimales = 2
  } = opciones;

  if (valor == null) return 0;

  // Convertir a string y quitar caracteres no numéricos (excepto . y - opcional)
  let limpio = String(valor)
    .replace(/[^0-9.,-]/g, '')       // elimina todo lo que no sea número, coma, punto o signo
    .replace(',', '.');              // normaliza coma a punto decimal

  // Eliminar signo si no se permite negativo
  if (!permitirNegativo) {
    limpio = limpio.replace(/-/g, '');
  }

  let num = parseFloat(limpio);

  if (isNaN(num)) return 0;

  // Redondear a X decimales
  if (typeof decimales === 'number') {
    num = parseFloat(num.toFixed(decimales));
  }

  return num;
}

export const CalcularUnitario = (item, tipo = '') => {
  const parcial = CalcularParcial(item, tipo);
  const factorVenta = (item?.factorVenta || 1) / 100;
  const unitario = sanearNumero(parcial) / sanearNumero(factorVenta);
  return unitario;
};

export const CalcularTotal = (item, tipo = '') => {
  if (!tipo) {
    return 0
  }
  const unitario = CalcularUnitario(item, tipo);
  const frecuencia = tipo == "M" ? parseInt(item.frecuencia) : 1;
  const cantidad = item?.cantidad || 0;
  const total = sanearNumero(unitario) * sanearNumero(cantidad) * sanearNumero(frecuencia)
  return total;
};

export const CalcularSubTotal = (items, tipo = '') => {
  if (!items || !tipo) {
    return 0;
  }
  const subTotal = items.filter(i => i?.tipo && i?.tipo != 0).reduce((a, b) => {
    const total_item = CalcularTotal(b, tipo)
    return sanearNumero(a) + sanearNumero(total_item);
  }, 0);
  return subTotal;
};

export const CalcularIva = (subtotal, iva) => {
  return sanearNumero(subtotal) * (sanearNumero(iva) / 100);
};

export const CalcularSubTotalFactura = (subtotal, totalIva) => {
  return sanearNumero(subtotal) + sanearNumero(totalIva);
};

export const CalcularDescuento = (subtotal, descuento) => {
  if (!descuento) {
    return 0;
  }
  return sanearNumero(subtotal) * (sanearNumero(descuento) / 100);
};

export const CalcularSubTotalDescuento = (subTotal, totalDescuento) => {
  return sanearNumero(subTotal) - sanearNumero(totalDescuento);
};

export const CalcularDescuentoIva = (subTotalDescuento, iva) => {
  let _iva = sanearNumero(iva)
  return sanearNumero(subTotalDescuento) * (_iva > 1 ? _iva / 100 : _iva);
};

export const CalcularTotalFactura = (subtotalFactura, totalDescuento) => {

  return sanearNumero(subtotalFactura) - sanearNumero(totalDescuento);
};

export const CalcularAdministracion = (subtotalFactura, administracion) => {
  return sanearNumero(subtotalFactura) * (sanearNumero(administracion) / 100);
};

export const CalcularImprevistos = (subtotalFactura, imprevisto) => {
  return sanearNumero(subtotalFactura) * (sanearNumero(imprevisto) / 100);
};

export const CalcularUtilidad = (subtotalFactura, utilidad) => {
  return sanearNumero(subtotalFactura) * (sanearNumero(utilidad) / 100);
};

export const CalcularIvaUtilidad = (totalUtilidad, iva) => {
  const ivaUtilidad = sanearNumero(totalUtilidad) * (sanearNumero(iva) / 100);
  return ivaUtilidad;
};

export const calcTotalSale = (quotation) => {
  
  if(!quotation){
    return 0
  }

  const {
    articulos = [],
    descuento = 0,
    iva = 0,
    tipo,
    iva_utilidad = 0,
    imprevistos = 0,
    administracion = 0,
    utilidad = 0 } = quotation;

  const subtotal = calcSubtotalQuote(articulos, tipo);
  if (quotation?.modo == 1) {
    const totalDescuento = CalcularDescuento(subtotal, descuento);
    const subTotalDescuento = CalcularSubTotalDescuento(subtotal, totalDescuento);
    const ivaDescuento = CalcularDescuentoIva(subTotalDescuento, iva);
    const totalFactura = CalcularTotalFactura(subTotalDescuento, -ivaDescuento);
    return totalFactura
  }

  const aiu_subtotal = calcSubtotalQuote(articulos, tipo);
  const totalAdministracion = CalcularAdministracion(aiu_subtotal, administracion);
  const totalImprevistos = CalcularImprevistos(aiu_subtotal, imprevistos);
  const totalUtilidad = CalcularUtilidad(aiu_subtotal, utilidad);
  const totalIvaUtilidad = CalcularIvaUtilidad(totalUtilidad, iva_utilidad);
  const totalDescuento = CalcularDescuento(aiu_subtotal, descuento);
  const aui_total = (
    subtotal +
    totalAdministracion +
    totalImprevistos +
    totalUtilidad +
    totalIvaUtilidad
  )

  return aui_total - totalDescuento


}

export const calcUnitCost=(item)=>{
   const unit_cost = sanearNumero(item?.materiales?.valor || 0) +
    sanearNumero(item?.contratista?.valor || 0) +
    sanearNumero(item?.equipos?.valor || 0) +
    sanearNumero(item?.mano_de_obra?.valor || 0) +
    sanearNumero(item?.transporte?.valor || 0) +
    sanearNumero(item?.viaticos?.valor || 0);

    return unit_cost
}

export const getUnitCost = (item) => {
  if (item?.factorVenta < 1) {
    return 0
  }
  if (!item?.factorVenta) {
    return 0
  }

  const unit_cost = sanearNumero(item?.materiales?.valor || 0) +
    sanearNumero(item?.contratista?.valor || 0) +
    sanearNumero(item?.equipos?.valor || 0) +
    sanearNumero(item?.mano_de_obra?.valor || 0) +
    sanearNumero(item?.transporte?.valor || 0) +
    sanearNumero(item?.viaticos?.valor || 0);
   
  const sales_factor = sanearNumero(item?.factorVenta) / 100;
 
  return unit_cost/sales_factor
}

export const getCostItem = (item, type) => {
  const unit_cost = getUnitCost(item)
  const qty = item?.cantidad ?? 0;
  const frecuency = type == "M" ? item?.frecuencia ?? 0 : 1
  return unit_cost * qty * frecuency
}

export const calcSubtotalQuote = (items, type) => {
  return items?.reduce((accumulate, item) => getCostItem(item, type) + accumulate, 0)
}

// Plain-text currency formatting for the printable/PDF report — antd's
// <Statistic> renders incorrectly under html2canvas (jsPDF's PDF export),
// cutting off or misplacing the value column, so the report uses this
// instead of <Statistic> anywhere it needs to appear in the generated PDF.
export const formatMoney = (value) => {
  const num = Math.round(sanearNumero(value) || 0);
  return num.toLocaleString('es-CO');
}



